import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error'
import { type RepoStandardResponse } from '@webapp/infrastructure/interfaces/repositories/RepoStandardResponse'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type ISettingsRepository } from '@webapp/platform/finance'
import { type GetFinanceSettingsResponse } from '../../types/GetFinanceSettingsResponse'

interface IDependency {
  httpClient: IHttpClient
}

export class SettingsRepository implements ISettingsRepository {
  constructor(private readonly deps: IDependency) {}

  async getFinanceSettings(): Promise<
    RepoStandardResponse<{
      isBudgetOverageEnabled: boolean
    }>
  > {
    try {
      const {
        data: { data },
      } = await this.deps.httpClient.get<GetFinanceSettingsResponse>(
        '/api/v3/settings/company/finance/'
      )

      return {
        data: {
          isBudgetOverageEnabled: data.budgetOvertureToggle,
        },
      }
    } catch (error) {
      throw throwRepoErrorFromApiV3Error(error)
    }
  }
}
